<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('approvalRequestFlow.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('approvalRequestFlow.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew({})">
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td>
              {{ record.approval_type ? record.approval_type.not_types : '' }}
            </td>
            <td class="text-center">{{ record.escalate_after_xx_hours }}</td>
            <td class="text-center">{{ record.escalate_times }}</td>
            <td>{{ record.approver_notification_template }}</td>
            <td>{{ record.initiator_notification_template }}</td>
            <td class="text-center">
              <a-switch
                v-model="record.is_enabled"
                size="small"
                @change="isEnabled(record)"
              />
            </td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="addNew(record)"
              >
                <i class="fa fa-edit" aria-hidden="true"></i>
              </a>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto detail">
              <thead>
                <tr>
                  <th width="5%">{{ $t('approvalRequestFlow.levelOrder') }}</th>
                  <th width="15%">
                    {{ $t('approvalRequestFlow.approverType') }}
                  </th>
                  <th>{{ $t('approvalRequestFlow.approver') }}</th>
                  <th width="15%">
                    {{ $t('approvalRequestFlow.approverTypeCc') }}
                  </th>
                  <th width="25%">
                    {{ $t('approvalRequestFlow.approverCc') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in prop.record.details" :key="index">
                  <td>{{ item.level_order }}</td>
                  <td>
                    {{
                      item.approver_type ? item.approver_type.approver_type : ''
                    }}
                  </td>
                  <td>
                    <treeselect
                      v-if="item.approver_type_id == 1"
                      :options="userOptions"
                      :placeholder="$t('approvalRequestFlow.user')"
                      v-model="item.approver_type_value"
                      :maxHeight="150"
                      disabled
                    />
                    <treeselect
                      v-if="item.approver_type_id == 2"
                      :options="roleOptions"
                      :placeholder="$t('approvalRequestFlow.mobileRole')"
                      v-model="item.approver_type_value"
                      :maxHeight="150"
                      disabled
                    />
                  </td>
                  <td>
                    {{
                      item.approver_type_cc
                        ? item.approver_type_cc.approver_type
                        : ''
                    }}
                  </td>
                  <td>
                    <treeselect
                      v-if="item.approver_type_cc_id == 1"
                      :options="userOptions"
                      :placeholder="$t('approvalRequestFlow.user')"
                      v-model="item.approver_type_cc_value"
                      :maxHeight="150"
                      disabled
                    />
                    <treeselect
                      v-if="item.approver_type_cc_id == 2"
                      :options="roleOptions"
                      :placeholder="$t('approvalRequestFlow.mobileRole')"
                      v-model="item.approver_type_cc_value"
                      :maxHeight="150"
                      disabled
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import FromAction from './form'
import Vmodal from 'vue-js-modal'
import Vue from 'vue'
Vue.use(Vmodal, { dynamic: true, injectModalsContainer: true })

export default {
  name: 'approvalRequestFlow',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('setting/approvalRequestFlow', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.setting.approvalRequestFlow.search
      },
      set (newValue) {
        this.$store.commit('setting/approvalRequestFlow/SET_SEARCH', newValue)
        this.$store.commit('setting/approvalRequestFlow/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t('approvalRequestFlow.approvalType')
        },
        {
          name: this.$t('approvalRequestFlow.escalateAfterHours'),
          style: 'text-align:center'
        },
        {
          name: this.$t('approvalRequestFlow.escalateTimes'),
          style: 'text-align:center'
        },
        {
          name: this.$t('approvalRequestFlow.approverNotificationTemplate')
        },
        {
          name: this.$t('approvalRequestFlow.initiatorNotificationTemplate')
        },
        {
          name: this.$t('approvalRequestFlow.isEnabled'),
          style: 'text-align:center'
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    userOptions () {
      return this.$store.state.setting.approvalRequestFlow.users.map(el => ({
        id: el.user_id,
        label: el.name
      }))
    },
    roleOptions () {
      return this.$store.state.setting.approvalRequestFlow.roles.map(el => ({
        id: el.mobile_role_id,
        label: el.role_name + ' => ' + el.description
      }))
    }
  },
  methods: {
    ...mapActions('setting/approvalRequestFlow', [
      'fetchUser',
      'fetchMobileRole'
    ]),
    fetchResource () {
      this.loading = true
      this.$store
        .dispatch('setting/approvalRequestFlow/fetchResource')
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('setting/approvalRequestFlow/fetch', { ...attributes })
        .then(() => {
          this.loading = false
          this.$store.commit('setting/approvalRequestFlow/SET_EDIT_DATA', {})
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew (data) {
      this.$store.commit('setting/approvalRequestFlow/SET_EDIT_DATA', data)
      this.$modal.show(
        FromAction,
        {
          data: data
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    isEnabled (record) {
      record._deleting = true
      this.$store
        .dispatch('setting/approvalRequestFlow/enable', {
          id: record.app_flow_id,
          data: record
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      Promise.all([vm.fetchUser(), vm.fetchMobileRole()])
      vm.fetchData()
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('setting/approvalRequestFlow/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
.detail td {
  padding: 0.2rem;
  vertical-align: middle;
}
</style>
